import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

const DrawerContext = createContext();

export function useDrawer() {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer deve ser usado dentro de DrawerProvider');
  }
  return context;
}

export function DrawerProvider({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const drawerWidth = 280;
  
  // Inicializa o drawer como aberto em desktop
  const [drawerOpen, setDrawerOpenState] = useState(() => {
    // Verifica se foi fechado manualmente antes
    const wasManuallyClosed = sessionStorage.getItem('drawerManuallyClosed') === 'true';
    return !isMobile && !wasManuallyClosed;
  });
  
  // Função para atualizar o drawer que também salva no sessionStorage
  const setDrawerOpen = useCallback((open) => {
    setDrawerOpenState(open);
    if (open) {
      sessionStorage.removeItem('drawerManuallyClosed');
    } else {
      sessionStorage.setItem('drawerManuallyClosed', 'true');
    }
  }, []);
  
  // Sincroniza com mudanças de tamanho de tela
  useEffect(() => {
    const wasManuallyClosed = sessionStorage.getItem('drawerManuallyClosed') === 'true';
    if (!isMobile && !drawerOpen && !wasManuallyClosed) {
      setDrawerOpenState(true);
    } else if (isMobile && drawerOpen) {
      setDrawerOpenState(false);
      sessionStorage.removeItem('drawerManuallyClosed');
    }
  }, [isMobile]); // Removido drawerOpen da dependência para evitar loop

  const value = {
    drawerOpen,
    setDrawerOpen,
    drawerWidth,
    isMobile
  };

  return (
    <DrawerContext.Provider value={value}>
      {children}
    </DrawerContext.Provider>
  );
}

